import { useTranslation } from "react-i18next";
import { ModalBasic } from "../../../shared/components/ModalBasic";
import { DialogProps } from "@mui/material";
import { AppButton } from "../../../shared/components/AppButton";
import { TModalsIds } from "../../../app/state/modalSlice/types";
import { useModalSelectors } from "../../../app/state/modalSlice/hook/use-modal-selectors";
import styles from "./styles.module.css";

interface Props extends Omit<DialogProps, "open"> {
  handleActions: (type: "download" | "set_to_artifact") => void;
  closeModal: (id: TModalsIds) => void;
}

export const FileTransferModal = ({
  closeModal,
  handleActions,
  ...rest
}: Props) => {
  const fileTransfer = useModalSelectors("file_transfer_modal");
  const { t } = useTranslation();

  return (
    <ModalBasic
      open={fileTransfer.isOpen}
      onClose={() => closeModal("file_transfer_modal")}
      {...rest}
    >
      <div className={styles["container"]}>
        <AppButton
          onClick={() => {
            handleActions("download");
            closeModal("file_transfer_modal");
          }}
          buttonType={"outlined"}
          className={styles["button"]}
        >
          {t("common.download_file")}
        </AppButton>
        <AppButton
          onClick={() => {
            handleActions("set_to_artifact");
            closeModal("file_transfer_modal");
          }}
          buttonType={"outlined"}
          className={styles["button"]}
        >
          {t("common.save_to_artifact")}
        </AppButton>
      </div>
    </ModalBasic>
  );
};
